import * as Yup from "yup";

export function initialValues(assistance) {
  return {
    title: assistance?.title || "",
    path: assistance?.path || "",
    role: assistance?.role || "",
    ejercicios: assistance?.ejercicios || "",
    miniature: assistance?.miniature || "",
    file: null,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required(true),
    path: Yup.string().required(true),
    role: Yup.string().required(true),
    ejercicios: Yup.string().required(true),
    miniature: Yup.string().required(true),
  });
}
